import { METRICS } from './constants';
import { publishClientSideMetrics, publishCustomMetrics } from '../handler/parentDataHandler';
import { getStationCode } from '../utils/networkUtil';

export const METRIC_PROCESS = 'SCC_SHIFTPLAN';
export const METRIC_PROCESS_LABOR_ALLOCATION = 'SCC_LABOR_ALLOCATION_PLAN';
export const METRIC_PROCESS_FLOW_PLANNER = METRIC_PROCESS;

export const FLOW_PLANNER_METRICS = {
  CREATE_PLAN: 'fp_createPlan',
  CREATE_PLAN_E2E: 'fp_createPlan_e2e',
  CREATE_OPTIMIZED_PLAN: 'fp_createOptimizedPlan',
  CREATE_OPTIMIZED_PLAN_E2E: 'fp_createOptimizedPlan_e2e',
  APPROVE_PLAN: 'fp_approvePlan',
  REJECT_PLAN: 'fp_rejectPlan',
  REPLAN: 'fp_replan',
  REPLAN_E2E: 'fp_replan_e2e',
  POLL_DURATION: 'fp_pollDuration',
  CALCULATE_PLAN: 'fp_calculatePlan',
  UPDATE_PLAN: 'fp_updatePlan',
  OPEN_OPTIMIZER: 'fp_openOptimizer',
  CALCULATE_OPTIMIZED_PLAN: 'fp_calculateOptimizedPlan',
  UPDATE_PLAN_FROM_OPTIMIZER: 'fp_updatePlanFromOptimizer',
  CANCEL_OPTIMIZER: 'fp_cancelOptimizer',
  OVERRIDE_VOLUME: 'fp_overrideVolume',
  OVERRIDE_VOLUME_DISTRIBUTION: 'fp_overrideVolumeDistribution',
  OVERRIDE_RATE_MULTIPLIER: 'fp_overrideRateMultiplier',
  OVERRIDE_SUPPORT_HEADCOUNT: 'fp_overrideSupportHeadcount',
  OVERRIDE_ATTENDANCE: 'fp_overrideAttendance',
  OVERRIDE_AUTOMATION_CONFIG: 'fp_overrideAutomationConfig',
  CREATE_PLAN_FAILED: 'fp_createPlanFailed',
  CREATE_OPTIMIZED_PLAN_FAILED: 'fp_createOptimizedPlanFailed',
  APPROVE_PLAN_FAILED: 'fp_approvePlanFailed',
  REJECT_PLAN_FAILED: 'fp_rejectPlanFailed',
  POLL_TIMEOUT: 'fp_pollTimeout',
  POLL_ERROR: 'fp_pollError',
  PLAN_FAILED: 'fp_planFailed',
  INIT_MODEL_FAILED: 'fp_initModelFailed',
  OVERRIDE_TIME_DISTRIBUTIONS: 'fp_overrideTimeDistributions',
  SELECT_CLASSIC_LAYOUT: 'fp_selectClassicLayout',
  SELECT_NEW_LAYOUT: 'fp_selectNewLayout'
};

export const CALL_METHODS = {
  GET_ALL_PLANS: 'getAllPlans',
  CREATE_PLAN: 'createPlan',
  GET_PLAN: 'getPlan',
  UPDATE_PLAN_STATUS: 'updatePlanStatus',
  UPDATE_OUTPUT: 'updateOutput'
};

export const LABOR_ALLOCATION_METRICS = {
  REMOVE_ALL_ASSOCIATES: 'removeAllAssociates',
  REMOVE_CLOCKED_OUT_ASSOCIATES: 'removeClockedOutAssociates',
  RERUN_ALLOCATION_PLAN: 'rerunAllocationPlan',
  SAVE_ALLOCATION_BOARD: 'saveAllocationBoard',
  TRACK_INTO_FCLM: 'trackIntoFCLM'
};

export const publishCount = (processName, metricName) => {
  const request = getMetricPublishRequest(processName, metricName, 1, METRICS.COUNT);
  publishClientSideMetrics(request);
};

export const publishTime = (processName, metricName, startTime) => {
  const metricValue = Date.now() - startTime;
  const request = getMetricPublishRequest(processName, metricName, metricValue, METRICS.TIME);
  publishClientSideMetrics(request);
};

const getMetricPublishRequest = (processName, metricName, metricValue, metricType) => {
  return {
    processName,
    metricName,
    metricValue,
    metricType
  };
};

export function logCustomMetrics(eventType, eventName) {
  let stationCode = getStationCode();
  publishCustomMetrics({
    eventType: eventType,
    eventName: eventName,
    stationCode: stationCode
  });
}

export const publishLaborAllocationCountMetric = (metricName) => {
  const stationCode = getStationCode();

  // Publish overall metric
  publishCount(METRIC_PROCESS_LABOR_ALLOCATION, metricName);

  // Publish station-level metric
  const stationProcessName = `${METRIC_PROCESS_LABOR_ALLOCATION}_${stationCode}`;
  publishCount(stationProcessName, metricName);
};

export const publishFlowPlannerCountMetric = (metricName) => {
  const stationCode = getStationCode();
  publishCount(METRIC_PROCESS_FLOW_PLANNER, metricName);
  publishCount(METRIC_PROCESS_FLOW_PLANNER, `${metricName}_${stationCode}`);
  logCustomMetrics('FLOW_PLANNER', metricName);
};

export const publishFlowPlannerTimeMetric = (metricName, startTime) => {
  const stationCode = getStationCode();
  publishTime(METRIC_PROCESS_FLOW_PLANNER, metricName, startTime);
  publishTime(METRIC_PROCESS_FLOW_PLANNER, `${metricName}_${stationCode}`, startTime);
};
